import React, { useEffect, useState } from 'react';
import { Form, FormCheck, Row, Col, Card, Modal, Spinner, Button } from "react-bootstrap";
import Select from "react-select";
import { useParams, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import MyApiClient from '../../../../api-client/MyApiClient';
import segnalaMancanti from '../../../components/Util/campiMancanti';
import "react-widgets/styles.css";
import { format } from 'date-fns';
import { conMotivo } from "../../../components/Util/erroreServer";
import { usePageTitle, useStatoInSolaLettura } from "../../../layouts/PageHeaderExtra";

const options = [
  { value: "PLAYERS", label: "Players" },
  { value: "GURUS", label: "Maestri" },
  { value: "JUNIORS", label: "Junior" },
  { value: "CLUB_MEMBERS", label: "Soci" },
  { value: "CLUB_COACHES", label: "Staff Tecnico" },
  { value: "CLUB_DIRECTORS", label: "CDA" },
];

export const ComunicazioneGenericheEdit = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [isEditable, setIsEditable] = useState(false);
  
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    type: 'GENERIC',
    subject: '',
    messageHtml: '',
    scheduled: false,
    scheduledAt_date: '',
    scheduledAt_time: '',
    scheduledAt: 0,
    recipientGroups: []
  });

  const [modalShowed, setModalShowed] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');

  const [confirmShowed, setConfirmShowed] = useState(false);
	const [onContinue, setOnContinue] = useState(null);

  const [loadingShowed, setLoadingShowed] = useState(false);

  // Titolo della pagina = titolo della comunicazione com'è salvato (non cambia mentre si scrive).
  const [titoloSalvato, setTitoloSalvato] = useState('');
  usePageTitle(titoloSalvato);
  // Stato in sola lettura accanto al titolo, come nella lista: Programmata finché non parte, poi Inviata
  useStatoInSolaLettura(titoloSalvato ? (isEditable ? 'Programmata' : 'Inviata') : '', isEditable ? 'bozza' : 'attivo');

  // «Elimina»: era nel menu a fine riga della lista, ora sta nella scheda (03/10/2026).
  // Si può eliminare solo una comunicazione ancora programmata, come prima.
  const [confermaElimina, setConfermaElimina] = useState(false);

  const eliminaComunicazione = () => {

    setConfermaElimina(false);

    const deleteData = async () => {
      try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
          const tokenDetails = JSON.parse(tokenDetailsString);
          const token = tokenDetails.idToken;
          const apiClient = new MyApiClient();

          setLoadingShowed(true);
          const saveResult = await apiClient.deleteCommunications(token, id);
          setLoadingShowed(false);

          if(!saveResult) {
            setModalTitle("Errore durante l'operazione");
            setModalText(conMotivo("Si è verificato un errore durante l'eliminazione"));
            setModalShowed(true);
          } else {
            navigate('/superadmin/comunicazioni');
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    deleteData();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleCheckboxChange = () => {
    setFormData(prevState => ({
      ...prevState,
      ['scheduled']: !isChecked
    }));
    setIsChecked(!isChecked);
  };

  const handleSelectChange = (selectedOptions) => {
    const selectedGroups = selectedOptions.map(option => option.value);
    setFormData(prevState => ({
        ...prevState,
        recipientGroups: selectedGroups
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
          const tokenDetails = JSON.parse(tokenDetailsString);
          let token = tokenDetails.idToken;
          const apiClient = new MyApiClient();

          setLoadingShowed(true);
          const [documentsData] = await Promise.all([
            apiClient.getCommunications(token)
          ]);
          setLoadingShowed(false);

          let formDataRead = null;
          if(documentsData) {
            documentsData.forEach(element => {
              if(element.id==id) {
                formDataRead = [];
                formDataRead.subject = element.subject;
                setTitoloSalvato(element.subject || '');
                formDataRead.messageHtml = element.messageHtml;
                formDataRead.recipientGroups = element.recipientGroups;
                formDataRead.scheduled = true;
                setIsChecked(true);

                let data_scheduled = format(element.scheduledAt, 'yyyy-MM-dd HH:mm');
                let data_scheduled_split = data_scheduled.split(' ');
                formDataRead.scheduledAt_date = data_scheduled_split[0];
                formDataRead.scheduledAt_time = data_scheduled_split[1];

                if(element.scheduledAt>Date.now()) {
                  setIsEditable(true);
                }
              }
            }); 
          }

          if(formDataRead) {
            setFormData(formDataRead);
          } else {
            setModalTitle("Errore durante l'operazione");
            setModalText('Errore durante la lettura.');
            setModalShowed(true);
            return;
          }
        }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    fetchData();

  }, []);

  const handleSaveClick = (e) => {
    e.preventDefault();

    // Dati mancanti: si evidenziano i campi, senza finestra (set-ui «Dati mancanti»)
    const mancanti = [];
    if (!(formData.subject || '').trim()) mancanti.push({ campo: 'com-titolo', messaggio: 'Manca il titolo della comunicazione' });
    if (!formData.recipientGroups || formData.recipientGroups.length === 0) mancanti.push({ campo: 'com-destinatari', messaggio: 'Manca la tipologia di destinatario: scegline almeno una' });
    if (isChecked && !formData.scheduledAt_date) mancanti.push({ campo: 'com-data', messaggio: 'Manca la data di invio' });
    if (isChecked && !formData.scheduledAt_time) mancanti.push({ campo: 'com-ora', messaggio: 'Manca l\'ora di invio' });
    if (!formData.messageHtml) mancanti.push({ campo: 'com-contenuto', messaggio: 'Manca il contenuto della comunicazione' });
    if (segnalaMancanti(mancanti) > 0) return;

    setOnContinue(() => () => continueSaveDoc());
		setConfirmShowed(true);
  };

  const continueSaveDoc = (row) => {

    setConfirmShowed(false);

    const saveData = async () => {
      try {
          const tokenDetailsString = sessionStorage.getItem('userDetails');
          if (tokenDetailsString) {
              const tokenDetails = JSON.parse(tokenDetailsString);
              const token = tokenDetails.idToken;
              const apiClient = new MyApiClient();

              const dateTimeStr = `${formData.scheduledAt_date}T${formData.scheduledAt_time}:00Z`;
              const date = new Date(dateTimeStr);
              const timestamp = date.getTime();
              formData.scheduledAt = timestamp;

              let data_insert = {
                'type': formData.type,
                'subject': formData.subject,
                'messageHtml': formData.messageHtml,
                'recipientGroups': formData.recipientGroups
              }

              if(formData.scheduledAt) {
                data_insert['scheduledAt'] = formData.scheduledAt;
              }

              setLoadingShowed(true);
              const saveResult = await apiClient.editCommunication(token, id, data_insert);
              setLoadingShowed(false);

              if (saveResult && saveResult.error) {
                setModalTitle("Errore durante l'operazione");
                setModalText("Si è verificato un errore durante il salvataggio (" + saveResult.error + ")");
                setModalShowed(true);
              } else {
                navigate('/superadmin/comunicazioni');
              }
          }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    saveData();
  };

  return (
    <>
      <style>
          {`
              [dir="ltr"] .ck.ck-dropdown .ck-dropdown__arrow {
                z-index: 0;
              }

              .ck.ck-editor__editable_inline > :first-child {
                height: 90%;
              }

              .ck-content {
                min-height: 200px;
                margin-bottom: 50px;
              }
          `}
      </style>

      <Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

      <Modal className="fade" show={confirmShowed} centered>
        <Modal.Header>
          <Modal.Title>Salvare la comunicazione?</Modal.Title>
          <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="col-xl-64">
              {formData.scheduled && <b>La comunicazione sarà inviata all'orario schedulato.</b>}
              {!formData.scheduled && <b>La comunicazione sarà inviata immediatamente.</b>}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
            Annulla
          </Button>
          <Button className="btn btn-primary btn-add" onClick={() => { setConfirmShowed(false); if (onContinue) onContinue(); }}>
            Salva
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={modalShowed} centered>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row><Col className="col-xl-64">{modalText}</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
              Chiudi
          </Button>
        </Modal.Footer>
      </Modal>
      
      <Form noValidate onSubmit={(e) => e.preventDefault()}>
        <Card>
          <Card.Header><h5>Crea una nuova comunicazione</h5></Card.Header>
          <Card.Body>
            <Row>
              <Col>
                <Form.Label htmlFor="com-titolo">Titolo *</Form.Label>
                <Form.Control id="com-titolo" type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Inserisci il titolo della comunicazione" />
              </Col></Row>
            <Row>
              <Col>
                <Form.Label className="mt-4" htmlFor="com-destinatari">Tipologia destinatario *</Form.Label>
                <Select
                  inputId="com-destinatari"
                  value={options.filter(option => formData.recipientGroups ? formData.recipientGroups.includes(option.value) : '')}
                  isMulti
                  options={options}
                  onChange={handleSelectChange}
                  placeholder="Seleziona la tipologia di destinatario a cui spedire"
                  style={{
                    lineHeight: "40px",
                    color: "#fd7e14",
                    paddingLeft: " 15px",
                  }
                  }
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Form.Group controlId="prodottoConListaAttesa">
                <FormCheck
                  className="d-flex"
                  type="checkbox"
                  label="Programma l'invio (se non selezionato la comunicazione verrà inviata immediatamente)"
                  value=""
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
              </Form.Group>
            </Row>
            {isChecked &&
              <Row>
                <Col>
                  <Form.Label htmlFor="com-data">Seleziona data *</Form.Label>
                  <Form.Control id="com-data" type="date" name="scheduledAt_date" value={formData.scheduledAt_date} onChange={handleChange} ></Form.Control>
                </Col>
                <Col>
                  <Form.Label htmlFor="com-ora">Seleziona ora *</Form.Label>
                  <Form.Control id="com-ora" type="time" name="scheduledAt_time" value={formData.scheduledAt_time} onChange={handleChange} ></Form.Control>
                </Col>
              </Row>
            }
            <Row>
              <Form.Label className="mt-4">Contenuto *</Form.Label>
              <div id="com-contenuto" className="custom-ekeditor">
                <CKEditor
                  editor={ClassicEditor}
                  data={formData.messageHtml}
                  // data="<p>Hello from CKEditor 5!</p>"
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    // console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    formData.messageHtml = data;
                  }}
                  onBlur={(event, editor) => {
                    // console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    // console.log('Focus.', editor);
                  }}
                />
              </div>
            </Row>
          </Card.Body>
        </Card>
        {/* Azioni della comunicazione: l'eliminazione a sinistra, le altre a destra. */}
        <div className="d-flex justify-content-between mt-4">
          {isEditable
            ? <button type="button" className="btn btn-danger btn-add" onClick={() => setConfermaElimina(true)}>Elimina comunicazione</button>
            : <div />}
          <div className="d-flex gap-4">
            <button type="button" className="btn btn-light" onClick={() => navigate('/superadmin/comunicazioni')}>Annulla</button>
            { isEditable && <button type="button" onClick={handleSaveClick} className="btn btn-primary">Salva</button> }
          </div>
        </div>
      </Form>

      <Modal className="fade" show={confermaElimina} onHide={() => setConfermaElimina(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Eliminare la comunicazione?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Eliminare la comunicazione «{titoloSalvato || 'senza titolo'}»? Non verrà inviata e l'operazione non si può annullare.
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button className="btn btn-light btn-add" onClick={() => setConfermaElimina(false)}>Annulla</Button>
          <Button className="btn btn-danger btn-add" onClick={eliminaComunicazione}>Elimina</Button>
        </Modal.Footer>
      </Modal>
    </>
  )

}
export default ComunicazioneGenericheEdit;